
      (function () {
        /* Product cards render this snippet repeatedly. The handlers work across
           every quick-buy dialog, so initialise them once per page. */
        if (window.__mekaQuickBuyRuntimeLoaded) return;
        window.__mekaQuickBuyRuntimeLoaded = true;

        if (!window.__qbBoostCSSInjected) {
          window.__qbBoostCSSInjected = true;

          var css = `
            .qb-dialog, .qb-dialog * { box-sizing: border-box; }

            .qb-dialog,
            .qb-dialog *,
            .qb-slot,
            .qb-slot *,
            .qb-btn {
              --button-border-color: transparent !important;
            }

            .qb-slot { margin-top: 4px; text-align: left; }

            .qb-btn{
              appearance: none;
              background: transparent !important;
              border: 0 !important;
              outline: none;
              padding: 0 !important;
              margin: 0 !important;
              box-shadow: none !important;

              display: inline-block;
              width: auto;
              max-width: 100%;

              text-align: left;
              cursor: pointer;

              color: #e86d5a !important;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.2;

              text-decoration-line: underline;
              text-decoration-color: #e86d5a;
              text-decoration-thickness: 1px;
              text-underline-offset: 3px;

              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .qb-btn[disabled]{ cursor: not-allowed; opacity: 0.55; text-decoration: none; }
            @media (max-width: 749px){ .qb-btn{ font-size: 14px; } }

            .qb-dialog {
              border: 0;
              padding: 0;
              margin: auto;
              width: min(980px, 94vw);
              max-width: 980px;
              background: #fff;
              border-radius: 14px;
              overflow: hidden;
              overscroll-behavior: contain;
            }
            .qb-dialog::backdrop { background: rgba(0,0,0,0.55); }

            .qb-dialog__inner {
              width: 100%;
              max-height: min(86vh, 860px);
              display: flex;
              flex-direction: column;
              overflow: hidden;
            }

            .qb-dialog__header {
              flex: 0 0 auto;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 12px;
              padding: 14px 16px;
            }

            @media (max-width: 749px) {
              .qb-dialog__header { padding-top: 28px; }
            }

           .qb-title-link { text-decoration: none; }

@media (max-width: 749px) {
  .qb-title-link {
    display: block;
    font-size: 20px !important;
    font-weight: 600 !important;
    margin-bottom: 4px !important;
  }
}

            .qb-dialog__title {
              font-size: 24px;
              font-weight: 700;
              margin-bottom: 6px;
              text-align: left;
              color:rgb(35, 34, 33) !important;
            }
            @media (max-width: 749px) {
              .qb-dialog__title { font-size: 22px !important;  font-weight: 700;}
            }

            .qb-close {
              appearance: none; border: 0 !important; background: transparent !important;
              font-size: 20px; line-height: 1;
              padding: 8px 10px; cursor: pointer;
              font-weight: 800;
              color: #000 !important;
              box-shadow: none !important;
            }
            .qb-close:focus { outline: 2px solid rgba(0,0,0,.3); outline-offset: 2px; }

            .qb-dialog__content {
              flex: 1 1 auto;
              display: grid;
              grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
              gap: 16px;
              padding: 16px;
              overflow: auto;
              overflow-x: hidden;
              overscroll-behavior: contain;
              -webkit-overflow-scrolling: touch;
            }

            .qb-media, .qb-details { min-width: 0; }
            .qb-details { display: flex; flex-direction: column; text-align: left; }

.qb-media__main {
  aspect-ratio: 1 / 1;
  overflow: hidden;
  position: relative;
  isolation: isolate;
}
.product-badge-new,
.qb-product-badge-new {
  position: absolute;
  top: 7px;
  right: 5px;
  left: auto;

  z-index: 20;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 71px;
  height: 24px;
  padding: 0;

  background: #5dcaaeff;
  color: #fff;

  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.08em;
  line-height: 1;

  border-radius: 999px;

  text-transform: uppercase;

  pointer-events: none;
  white-space: nowrap;
}

.qb-product-badge-new {
  z-index: 5;
}

@media (max-width: 749px) {
  .product-badge-new,
  .qb-product-badge-new {
    top: 7px;
    right: 5px;
    width: 55px;
    font-size: 9px !important;
    height: 18px;
    font-size: 11px;
  }
}
            .qb-media__main img{
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: opacity 140ms ease;
            }
            .qb-media__main img.qb-img--loading { opacity: 0.35; }

            .qb-media__thumbs {
              margin-top: 10px;
              display: flex;
              align-items: flex-start;
              gap: 10px;
              overflow-x: auto;
              overflow-y: hidden;
              padding-bottom: 4px;
              -webkit-overflow-scrolling: touch;
            }
            .qb-thumb {
              flex: 0 0 72px;
              width: 72px;
              aspect-ratio: 1 / 1;
              height: auto;
              border: 1px solid rgba(0,0,0,0.12);
              background: #fff;
              padding: 0;
              cursor: pointer;
              overflow: hidden;
            }
            .qb-thumb img{ width: 100%; height: 100%; object-fit: cover; display: block; }
            .qb-thumb--hidden { display: none !important; }

            .qb-price {
              display: flex;
              gap: 10px;
              align-items: baseline;
              justify-content: flex-start;
              font-size: 18px !important;
              padding-top:5px;
              color:rgb(35, 34, 33) !important;
            }
            .qb-price__compare { opacity: 0.7; text-decoration: line-through; }

            .qb-color-swatches { display: flex; flex-wrap: wrap; gap: 1px; }

            .qb-color-input {
              position: absolute !important;
              width: 1px !important;
              height: 1px !important;
              padding: 0 !important;
              margin: -1px !important;
              overflow: hidden !important;
              clip: rect(0,0,0,0) !important;
              white-space: nowrap !important;
              border: 0 !important;
            }

            .qb-color-swatch {
              display: inline-flex !important;
              width: 40px !important;
              height: 40px !important;
              border-radius: 8px !important;
              border: 1px solid rgba(0,0,0,0.15) !important;
              overflow: hidden !important;
              padding: 0 !important;
              cursor: pointer;
              background: #fff;
              align-items: center;
              justify-content: center;
            }

            .qb-color-swatch img{ height: 100%; object-fit: cover; display: block; }

            .qb-color-swatch__fallback{
              font-size: 10px;
              line-height: 1.1;
              padding: 4px;
              text-align: center;
            }

            .qb-color-input:checked + .qb-color-swatch {
              border-color: #e86d5a !important;
            }

            .qb-options .qb-option { margin-bottom: 3px; }
            .qb-options .qb-option:last-child { margin-bottom: 0; }

            .qb-qty {
              margin-top: 25px;
              display: block;
            }

            .qb-qty-dd{
              position: relative;
              width: 100%;
            }

            .qb-qty-dd__label{
              position: absolute;
              left: 18px;
              top: 7px;
              font-size: 0.75rem;
              line-height: 1;
              opacity: 0.65;
              pointer-events: none;
              color: #000;
              z-index: 2;
            }

            .qb-qty-dd__trigger{
              appearance: none;
              -webkit-appearance: none;
              width: 100%;
              height: 46.6px;

              border: 1px solid rgba(0,0,0,0.15) !important;
              border-radius: 999px;
              background: #fff;
              box-shadow: none !important;

              padding: 20px 46px 8px 18px;
              text-align: left;

              font-size: 16px;
              line-height: 1.2;
              color: #000;
              cursor: pointer;
            }

            .qb-qty-dd__trigger:focus{
              outline: none;
              border-color: rgba(0,0,0,0.35) !important;
            }

            .qb-qty-dd__custom-input {
              appearance: none;
              -webkit-appearance: none;
              width: 100%;
              height: 46.6px;

              border: 1px solid rgba(0,0,0,0.15) !important;
              border-radius: 999px;
              background: #fff;
              box-shadow: none !important;

              padding: 20px 18px 8px 18px;
              text-align: left;

              font-size: 16px;
              line-height: 1.2;
              color: #000;
            }

            .qb-qty-dd__custom-input:focus {
              outline: none;
              border-color: rgba(0,0,0,0.35) !important;
            }

            .qb-qty-dd::after{
              content: "";
              position: absolute;
              right: 18px;
              top: 50%;
              width: 8px;
              height: 8px;
              border-right: 2px solid rgba(0,0,0,0.7);
              border-bottom: 2px solid rgba(0,0,0,0.7);
              transform: translateY(-30%) rotate(45deg);
              pointer-events: none;
              z-index: 2;
              transition: transform 0.2s ease;
            }

            .qb-qty-dd.dropdown-position-above::after {
              transform: translateY(-70%) rotate(-135deg);
            }

            .qb-qty-dd.is-custom::after {
              display: none;
            }

            .qb-qty-dd__menu{
              position: absolute;
              left: 0;
              right: 0;
              background: #fff;

              border: 1px solid rgba(0,0,0,0.12);
              border-radius: 14px;

              box-shadow: 0 10px 24px rgba(0,0,0,0.18);
              padding: 8px 0;

              max-height: 200px;
              overflow-y: auto;
              overflow-x: hidden;

              display: none;
              z-index: 30;
            }

            .qb-qty-dd.dropdown-position-above .qb-qty-dd__menu {
              bottom: calc(100% + 10px);
              top: auto;
            }

            .qb-qty-dd.dropdown-position-below .qb-qty-dd__menu {
              top: calc(100% + 10px);
              bottom: auto;
            }

            .qb-qty-dd.is-open .qb-qty-dd__menu{ display: block; }

            .qb-qty-dd__option{
              appearance: none;
              width: 100%;
              border: 0 !important;
              background: transparent;
              box-shadow: none !important;

              padding: 14px 18px;
              text-align: left;

              font-size: 18px;
              line-height: 1.2;
              color: #2b2b2b;
              cursor: pointer;
              border-radius: 0;
            }

            .qb-qty-dd__option:hover,
            .qb-qty-dd__option:focus{
              background: rgba(0,0,0,0.04);
              outline: none;
            }

            .qb-qty-dd__option.is-selected{
              background: rgba(0,0,0,0.06);
            }

            .qb-qty-dd__menu::-webkit-scrollbar{ width: 10px; }
            .qb-qty-dd__menu::-webkit-scrollbar-track{ background: transparent; }
            .qb-qty-dd__menu::-webkit-scrollbar-thumb{
              background: rgba(0,0,0,0.35);
              border-radius: 999px;
              border: 3px solid #fff;
            }

            .qb-atc { width: 100%; margin-top: 12px; }

            .qb-view { text-align: center; margin-top: 16px; margin-bottom: 12px; }
            .qb-view .standard-link { font-size: 14px !important; }

            @media (max-width: 749px) {
              .qb-dialog {
                width: 100vw;
                max-width: 100vw;
                height: 100dvh;
                max-height: 100dvh;
                border-radius: 0;
              }
              .qb-dialog__inner { max-height: 100dvh; }
              .qb-dialog__content { grid-template-columns: 1fr; padding: 12px; }
              .qb-thumb { flex: 0 0 64px; width: 64px; }
              .qb-color-swatch { width: 36px !important; height: 36px !important; border-radius: 7px !important; }
              .qb-atc { height: calc(46.6px + 4px); min-height: calc(46.6px + 4px); }
            }

            .qb-dialog button { min-width: 0 !important; }
            .qb-close {
              min-width: 0 !important;
              width: 40px !important;
              max-width: 40px !important;
              padding: 0 !important;
              margin: 0 !important;
              display: inline-flex !important;
              align-items: center !important;
              justify-content: center !important;
            }
.product-block__swatches {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1px;
}

.product-block__swatches-more-label {
  display: inline-flex;
  align-items: center;
  line-height: 1;
  white-space: nowrap;
}
            .qb-dialog .qb-close::before,
            .qb-dialog .qb-close::after {
              border-color: transparent !important;
              box-shadow: none !important;
            }
}
            /* ── Quick Buy sold-out styles ── */

            /* Pills (non-color text labels) */
            .qb-dialog .opt-label.opt-label--soldout:not(.qb-color-swatch) {
              position: relative;
              color: #d3d0d0;
              pointer-events: auto;
              cursor: not-allowed;
              overflow: hidden;
            }

            .qb-dialog .opt-label.opt-label--soldout:not(.qb-color-swatch)::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(
                to top right,
                transparent calc(50% - 0.75px),
                #d3d0d0 calc(50% - 0.75px),
                #d3d0d0 calc(50% + 0.75px),
                transparent calc(50% + 0.75px)
              );
              border-radius: inherit;
              pointer-events: none;
            }

            /* Color swatches (image-based) */
            .qb-dialog .qb-color-swatch.opt-label--soldout {
              opacity: 0.4;
              position: relative;
            }

            .qb-dialog .qb-color-swatch.opt-label--soldout::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(
                to top right,
                transparent calc(50% - 0.75px),
                #d3d0d0 calc(50% - 0.75px),
                #d3d0d0 calc(50% + 0.75px),
                transparent calc(50% + 0.75px)
              );
              border-radius: inherit;
              pointer-events: none;
              z-index: 1;
            }
              /* ── Quick Buy preorder notice ── */
               .qb-preorder-notice {
              padding: 8px 12px;
              margin-top: 12px;
              margin-bottom: 12px;
              background: #fdfaf3;
              border-radius: 8px;
              color: #e86d5a;
              font-size: 14px;
              font-weight: 600;
              line-height: 1.4;
              text-align: center !important;
            }

            .qb-atc.qb-atc--preorder {
              /* Style the preorder button differently if needed*/
            }
                        /* ── Fix sold-out line escaping dialog ── */
            .qb-dialog {
              overflow: hidden;
            }

            .qb-dialog__inner {
              overflow: hidden;
            }

            .qb-dialog__content {
              position: relative;
            }

            .qb-dialog .opt-label.opt-label--soldout:not(.qb-color-swatch) {
              position: relative;
              color: #d3d0d0;
              pointer-events: auto;
              cursor: not-allowed;
              overflow: hidden;
            }

            .qb-dialog .opt-label.opt-label--soldout:not(.qb-color-swatch)::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                to top right,
                transparent calc(50% - 0.75px),
                #d3d0d0 calc(50% - 0.75px),
                #d3d0d0 calc(50% + 0.75px),
                transparent calc(50% + 0.75px)
              );
              border-radius: inherit;
              pointer-events: none;
              z-index: 1;
            }

            .qb-dialog .qb-color-swatch.opt-label--soldout {
              opacity: 0.4;
              position: relative;
              overflow: hidden;
            }

            .qb-dialog .qb-color-swatch.opt-label--soldout::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                to top right,
                transparent calc(50% - 0.75px),
                #d3d0d0 calc(50% - 0.75px),
                #d3d0d0 calc(50% + 0.75px),
                transparent calc(50% + 0.75px)
              );
              border-radius: inherit;
              pointer-events: none;
              z-index: 1;
            }
          `;

          var style = document.createElement('style');
          style.setAttribute('data-qb-boost-style', 'true');
          style.appendChild(document.createTextNode(css));
          document.head.appendChild(style);
        }

        if (window.__qbBoostJSInjected) return;
        window.__qbBoostJSInjected = true;

        var scrollLock = { locked: false, scrollY: 0 };

        function lockScroll() {
          if (scrollLock.locked) return;
          scrollLock.locked = true;
          scrollLock.scrollY = window.scrollY || window.pageYOffset || 0;
          document.body.style.position = 'fixed';
          document.body.style.top = '-' + scrollLock.scrollY + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
          document.body.style.overflow = 'hidden';
          document.documentElement.style.overflow = 'hidden';
        }

        function unlockScroll() {
          if (!scrollLock.locked) return;
          scrollLock.locked = false;
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
          window.scrollTo(0, scrollLock.scrollY);
        }

        function closeAllQtyDropdowns(exceptWrap) {
          document.querySelectorAll('.qb-qty-dd.is-open').forEach(function(w){
            if (exceptWrap && w === exceptWrap) return;
            w.classList.remove('is-open');
            var trigger = w.querySelector('[data-qb-qty-trigger]');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          });
        }

        function setQtyForWrap(wrap, qty) {
          if (!wrap) return;
          var hidden = wrap.querySelector('[data-qb-qty-input]');
          var valueEl = wrap.querySelector('[data-qb-qty-value]');
          var customInput = wrap.querySelector('[data-qb-qty-custom-input]');
          var trigger = wrap.querySelector('[data-qb-qty-trigger]');

          if (qty === '10+') {
            if (hidden) hidden.value = '10';
            if (customInput) {
              customInput.value = '10';
              customInput.style.display = 'block';
              customInput.focus();
            }
            if (trigger) trigger.style.display = 'none';
            wrap.classList.add('is-custom');
          } else {
            if (hidden) hidden.value = String(qty);
            if (valueEl) valueEl.textContent = String(qty);
            if (customInput) customInput.style.display = 'none';
            if (trigger) trigger.style.display = 'block';
            wrap.classList.remove('is-custom');
          }

          wrap.querySelectorAll('[data-qb-qty-option]').forEach(function(opt){
            var optVal = opt.getAttribute('data-qb-qty-option');
            var isSel = (optVal === qty) || (qty !== '10+' && optVal === String(qty));
            opt.classList.toggle('is-selected', isSel);
            opt.setAttribute('aria-selected', isSel ? 'true' : 'false');
          });
        }

        function positionDropdown(wrap) {
          if (!wrap) return;

          var trigger = wrap.querySelector('[data-qb-qty-trigger]');
          var menu = wrap.querySelector('.qb-qty-dd__menu');
          if (!trigger || !menu) return;

          var dialog = wrap.closest('.qb-dialog');
          if (!dialog) return;

          var dialogContent = dialog.querySelector('.qb-dialog__content');
          if (!dialogContent) return;

          var triggerRect = trigger.getBoundingClientRect();
          var dialogRect = dialogContent.getBoundingClientRect();

          var spaceBelow = dialogRect.bottom - triggerRect.bottom;
          var spaceAbove = triggerRect.top - dialogRect.top;

          var menuHeight = 200 + 20;

          wrap.classList.remove('dropdown-position-above', 'dropdown-position-below');

          if (spaceBelow >= menuHeight || spaceBelow >= spaceAbove) {
            wrap.classList.add('dropdown-position-below');
          } else {
            wrap.classList.add('dropdown-position-above');
          }
        }

        function openDialog(dialog, openerBtn) {
          if (!dialog) return;
          dialog.__qbOpener = openerBtn || null;

          closeAllQtyDropdowns();

          lockScroll();
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', 'open');

          applyStandColorRule(dialog);
          filterThumbnailsBySelectedOptions(dialog);
        }

        function blurOpener(dialog) {
          if (!dialog) return;
          if (dialog.__qbOpener && typeof dialog.__qbOpener.blur === 'function') {
            dialog.__qbOpener.blur();
          }
          dialog.__qbOpener = null;
        }

        function closeDialog(dialog) {
          if (!dialog) return;
          closeAllQtyDropdowns();
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
          unlockScroll();
          setTimeout(function () { blurOpener(dialog); }, 0);
        }

        function formatMoneyWithDollar(cents) {
          cents = Number(cents || 0);
          return '$' + (cents / 100).toFixed(2);
        }

                function ajaxAddToCart(variantId, quantity, callback) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1) })
          })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            fetch('/cart.js')
              .then(function(r){ return r.json(); })
              .then(function(cart){
                var countEls = document.querySelectorAll(
                  '.cart-link__count, .cart-count, [data-cart-count], .js-cart-count, #CartCount, .site-header__cart-count, .header-cart__count'
                );
                countEls.forEach(function(el){
                  el.textContent = cart.item_count;
                });

                if (typeof $ !== 'undefined' && typeof theme !== 'undefined') {
                  var itemData = data;
                  var productImage = itemData.featured_image ? itemData.featured_image.url : '';
                  var productQty = itemData.quantity > 1 ? ' <span class="cart-summary__quantity">' + itemData.quantity + '</span>' : '';

                  var $template = $([
                    '<div class="added-notice global-border-radius added-notice--pre-reveal">',
                    '<div class="added-notice__header">',
                    '<span class="added-notice__title">', theme.strings.addedToCartPopupTitle, '</span>',
                    '<a class="added-notice__close feather-icon" href="#" aria-label="', theme.strings.close, '">', theme.icons.close, '</a>',
                    '</div>',
                    '<div class="cart-summary global-border-radius">',
                    '<div class="cart-summary__product">',
                    '<div class="cart-summary__product-image"><img class="global-border-radius" src="', productImage, '" role="presentation" alt=""></div>',
                    '<div class="cart-summary__product__description">',
                    '<div class="cart-summary__product-title">', itemData.product_title, productQty, '</div>',
                    '<div class="cart-summary__price">', theme.Shopify.formatMoney(itemData.final_line_price, theme.moneyFormatWithCodeForCartPreference), '</div>',
                    '</div>',
                    '</div>',
                    '</div>',
                    '<div class="cart-summary__footer">',
                    '<div class="cart-summary__total-quantity-row">',
                    '<span>', theme.strings.addedToCartPopupItems, '</span>',
                    '<span>', cart.item_count, '</span>',
                    '</div>',
                    '<div class="cart-summary__total-price-row large-text">',
                    '<span>', theme.strings.addedToCartPopupSubtotal, '</span>',
                    '<span class="theme-money">', theme.Shopify.formatMoney(cart.total_price, theme.moneyFormatWithCodeForCartPreference), '</span>',
                    '</div>',
                    '<a href="', theme.routes.cart_url, '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">', theme.strings.addedToCartPopupGoToCart, '</a>',
                    '</div>',
                    '</div>'].join(''));

                  $template.appendTo('body');

                  $template.on('click', '.added-notice__close', function(e) {
                    e.preventDefault();
                    clearTimeout(theme.addedToCartNoticeHideTimeoutId);
                    $template.addClass('added-notice--pre-reveal');
                    setTimeout(function() {
                      $template.remove();
                    }, 300);
                  });

                  setTimeout(function () {
                    $template.removeClass('added-notice--pre-reveal');
                  }, 10);

                  theme.addedToCartNoticeHideTimeoutId = setTimeout(function () {
                    $template.find('.added-notice__close').trigger('click');
                  }, 5000);
                }

                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              })
              .catch(function(){});
            if (typeof callback === 'function') callback(null, data);
          })
          .catch(function(err) {
            if (typeof callback === 'function') callback(err, null);
          });
        }
        
        function activateDialogImages(dialog) {
          if (!dialog) return;
          dialog.querySelectorAll('img[data-qb-deferred-src]').forEach(function(image) {
            var thumb = image.closest('[data-qb-thumb]');
            if (thumb && thumb.classList.contains('qb-thumb--hidden')) return;
            image.src = image.getAttribute('data-qb-deferred-src');
            image.removeAttribute('data-qb-deferred-src');
          });
        }

        function getSelectedOptions(dialog) {
          var optionFieldsets = dialog.querySelectorAll('[data-qb-option]');
          var selected = [];
          optionFieldsets.forEach(function (fs) {
            var idx = Number(fs.getAttribute('data-option-index'));
            var checked = fs.querySelector('input[type="radio"]:checked');
            selected[idx] = checked ? checked.value : null;
          });
          return selected;
        }

        function findVariant(productJson, selectedOptions) {
          if (!productJson || !productJson.variants) return null;
          return productJson.variants.find(function (v) {
            if (!v.options) return false;
            for (var i = 0; i < selectedOptions.length; i++) {
              if (selectedOptions[i] == null) return false;
              if (v.options[i] !== selectedOptions[i]) return false;
            }
            return true;
          }) || null;
        }

         function getDialogData(dialog) {
          if (dialog.__qbDataCache) return dialog.__qbDataCache;

          var productJsonEl = dialog.querySelector('[data-qb-product-json]');
          var variantImageMapEl = dialog.querySelector('[data-qb-variant-image-map]');
          var productJson = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
          var variantImageMap = variantImageMapEl ? JSON.parse(variantImageMapEl.textContent) : {};

          dialog.__qbDataCache = { productJson: productJson, variantImageMap: variantImageMap };
          return dialog.__qbDataCache;
        }

        /* ── Quick Buy: sold-out state logic (cached) ── */
        var QB_INCLUDED_OPTIONS = ['color', 'stand color'];

        function normQb(s) {
          return (s || '').toString().trim().toLowerCase();
        }

        function setMainImage(dialog, src) {
          var mainImg = dialog.querySelector('[data-qb-main-image]');
          if (!mainImg || !src) return;
          if (mainImg.getAttribute('src') === src) return;
          mainImg.removeAttribute('data-qb-deferred-src');
          mainImg.classList.add('qb-img--loading');
          mainImg.src = src;
          if (mainImg.decode) {
            mainImg.decode().catch(function(){}).finally(function () {
              mainImg.classList.remove('qb-img--loading');
            });
          } else {
            mainImg.onload = function () { mainImg.classList.remove('qb-img--loading'); };
          }
        }

        function getMediaFilterOptionIndexes(dialog) {
          var el = dialog.querySelector('[data-qb-media-filter-option-indexes]');
          if (!el) return null;
          try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
        }

        function getSelectedValueAtOptionIndex(dialog, optIndex) {
          if (optIndex == null || optIndex < 0) return null;
          var fs = dialog.querySelector('[data-qb-option][data-option-index="' + optIndex + '"]');
          if (!fs) return null;
          var checked = fs.querySelector('input[type="radio"]:checked');
          return checked ? (checked.value || '') : null;
        }

        function normBase(val) {
          return String(val || '').toLowerCase().trim();
        }

        function normSize(val) {
          var base = normBase(val);
          base = base.split('(')[0].trim();
          base = base.replace(/[""]/g, '"').trim();
          var first = base.split(/\s+/)[0];
          return first || '';
        }

        function normStand(val) {
          return normBase(val)
            .replace(/\bstand\b/g, '')
            .replace(/\s+/g, ' ')
            .trim();
        }

        function flexMatch(selected, mediaVal, type) {
          if (!mediaVal || !String(mediaVal).trim()) return true;
          if (!selected || !String(selected).trim()) return true;

          var sN, mN;
          if (type === 'size') {
            sN = normSize(selected);
            mN = normSize(mediaVal);
            return (sN === mN) || (sN.indexOf(mN) !== -1) || (mN.indexOf(sN) !== -1);
          } else if (type === 'stand') {
            sN = normStand(selected);
            mN = normStand(mediaVal);
            return (sN === mN) || (sN.indexOf(mN) !== -1) || (mN.indexOf(sN) !== -1);
          } else {
            sN = normBase(selected);
            mN = normBase(mediaVal);
            return (sN === mN);
          }
        }

                function matchLightingQb(selectedValue, requiredValue) {
          var s = normBase(selectedValue);
          var r = normBase(requiredValue);
          if (!s || !r) return true;
          if (s === 'none' && r === 'regular') return true;
          return s === r;
        }

        function filterThumbnailsBySelectedOptions(dialog) {
          if (!dialog) return;

          var idx = getMediaFilterOptionIndexes(dialog);
          if (!idx) return;

          var selectedColor    = getSelectedValueAtOptionIndex(dialog, idx.color);
          var selectedSize     = getSelectedValueAtOptionIndex(dialog, idx.size);
          var selectedStand    = getSelectedValueAtOptionIndex(dialog, idx.stand);
          var selectedLighting = getSelectedValueAtOptionIndex(dialog, idx.lighting);

          var thumbsContainer = dialog.querySelector('[data-qb-thumbs-container]');
          if (!thumbsContainer) return;

          var thumbs = thumbsContainer.querySelectorAll('[data-qb-thumb]');
          if (!thumbs.length) return;

          var hasLightingOption = (idx.lighting != null && idx.lighting >= 0);
          var hasAnyMatch = false;

          thumbs.forEach(function(thumb) {
            var tColor    = thumb.getAttribute('data-qb-thumb-color') || '';
            var tSize     = thumb.getAttribute('data-qb-thumb-size') || '';
            var tStand    = thumb.getAttribute('data-qb-thumb-stand') || '';
            var tLighting = thumb.getAttribute('data-qb-thumb-lighting') || '';

            var match =
              flexMatch(selectedColor, tColor, 'color') &&
              flexMatch(selectedSize,  tSize,  'size') &&
              flexMatch(selectedStand, tStand, 'stand');

            if (match && hasLightingOption) {
              if (tLighting) {
                match = matchLightingQb(selectedLighting, tLighting);
              } else if (normBase(tColor) === 'rgb' || normBase(tColor) === 'regular') {
                match = matchLightingQb(selectedLighting, tColor);
              }
            }

            if (match) {
              thumb.classList.remove('qb-thumb--hidden');
              hasAnyMatch = true;
            } else {
              thumb.classList.add('qb-thumb--hidden');
            }
          });

          if (!hasAnyMatch) {
            thumbs.forEach(function(thumb) {
              thumb.classList.remove('qb-thumb--hidden');
            });
          }

          var firstVisible = thumbsContainer.querySelector('[data-qb-thumb]:not(.qb-thumb--hidden)');
          if (firstVisible) {
            var src = firstVisible.getAttribute('data-qb-image');
            if (src) setMainImage(dialog, src);
          }
          activateDialogImages(dialog);
        }

        function applyStandColorRule(dialog) {
          if (!dialog) return;

          var cfgEl = dialog.querySelector('[data-qb-stand-color-logic]');
          if (!cfgEl) return;

          var cfg = null;
          try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
          if (!cfg || !cfg.enabled) return;

          var sizeIdx = Number(cfg.sizeOptionIndex);
          var standIdx = Number(cfg.standColorOptionIndex);
          if (!Number.isFinite(sizeIdx) || !Number.isFinite(standIdx) || sizeIdx < 0 || standIdx < 0) return;

          var sizeFs = dialog.querySelector('[data-qb-option][data-option-index="' + sizeIdx + '"]');
          var standFs = dialog.querySelector('[data-qb-option][data-option-index="' + standIdx + '"]');
          if (!sizeFs || !standFs) return;

          var sizeChecked = sizeFs.querySelector('input[type="radio"]:checked');
          var sizeVal = sizeChecked ? sizeChecked.value : null;

          var standRadios = Array.prototype.slice.call(standFs.querySelectorAll('input[type="radio"]'));

          function getLabelForRadio(radio) {
            if (!radio) return null;
            var id = radio.getAttribute('id');
            if (id) return standFs.querySelector('label[for="' + id + '"]');
            var next = radio.nextElementSibling;
            return (next && next.tagName === 'LABEL') ? next : null;
          }

          function hideRadio(radio) {
            var label = getLabelForRadio(radio);
            radio.dataset.qbHiddenByRule = '1';
            radio.style.display = 'none';
            radio.disabled = true;
            if (label) {
              label.dataset.qbHiddenByRule = '1';
              label.style.display = 'none';
            }
          }

          function showRadio(radio) {
            var label = getLabelForRadio(radio);
            if (radio.dataset.qbHiddenByRule) {
              delete radio.dataset.qbHiddenByRule;
              radio.style.display = '';
            }
            radio.disabled = false;
            if (label && label.dataset.qbHiddenByRule) {
              delete label.dataset.qbHiddenByRule;
              label.style.display = '';
            }
          }

          standFs.style.display = '';

          if (sizeVal === cfg.restrictedSizeValue) {
            var forcedRadio = standRadios.find(function(r){ return r.value === cfg.forcedStandColorValue; });

            standRadios.forEach(function(radio){
              if (radio.value === cfg.forcedStandColorValue) {
                showRadio(radio);
              } else {
                hideRadio(radio);
              }
            });

            if (forcedRadio) forcedRadio.checked = true;
          } else {
            standRadios.forEach(function(radio){ showRadio(radio); });
          }
        }

              /* ── Quick Buy preorder logic ── */
        function getQbPreorderMap(dialog) {
          if (dialog.__qbPreorderMapCache !== undefined) return dialog.__qbPreorderMapCache;
          var el = dialog.querySelector('[data-qb-preorder-map]');
          if (!el) { dialog.__qbPreorderMapCache = null; return null; }
          try {
            dialog.__qbPreorderMapCache = JSON.parse(el.textContent || '{}');
          } catch (e) {
            dialog.__qbPreorderMapCache = null;
          }
          return dialog.__qbPreorderMapCache;
        }

        function isQbPreorderProduct(dialog) {
          if (dialog.__qbIsPreorderCache !== undefined) return dialog.__qbIsPreorderCache;
          var el = dialog.querySelector('[data-qb-is-preorder]');
          if (!el) { dialog.__qbIsPreorderCache = false; return false; }
          try {
            var suffix = JSON.parse(el.textContent || '""');
            dialog.__qbIsPreorderCache = (typeof suffix === 'string' && suffix.indexOf('preorder') !== -1);
          } catch (e) {
            dialog.__qbIsPreorderCache = false;
          }
          return dialog.__qbIsPreorderCache;
        }

        function updateQbPreorder(dialog, variant) {
          if (!dialog) return;

          var noticeEl = dialog.querySelector('.qb-preorder-notice');
          var textEl = dialog.querySelector('[data-qb-preorder-text]');
          var atcBtn = dialog.querySelector('[data-qb-atc]');
          var isPreorderProduct = isQbPreorderProduct(dialog);
          var preorderMap = getQbPreorderMap(dialog);

          // If not a preorder product and no preorder map, skip entirely
          if (!isPreorderProduct && !preorderMap) {
            if (noticeEl) noticeEl.style.display = 'none';
            return;
          }

          if (!noticeEl || !textEl) return;

          // No variant found at all
          if (!variant) {
            noticeEl.style.display = 'none';
            if (atcBtn) {
              atcBtn.classList.remove('qb-atc--preorder');
              atcBtn.textContent = 'Unavailable';
              atcBtn.disabled = true;
            }
            return;
          }

          // Variant exists but is not available AND product is NOT set to
          // "continue selling when out of stock"
          // Note: Shopify sets variant.available = true when "continue selling" is on,
          // even if inventory is 0. So if available is true, we MUST allow add to cart.
          if (!variant.available) {
            noticeEl.style.display = 'none';
            if (atcBtn) {
              atcBtn.classList.remove('qb-atc--preorder');
              if (isPreorderProduct) {
                atcBtn.textContent = 'Coming Soon';
              } else {
                atcBtn.textContent = theme.strings.soldOut;
              }
              atcBtn.disabled = true;
            }
            return;
          }

          // Variant IS available (either in stock, or "continue selling" is on)
          var message = preorderMap ? preorderMap[String(variant.id)] : null;

          if (message) {
            // Has a variant-level preorder message
            textEl.textContent = message;
            noticeEl.style.display = 'block';
            if (atcBtn) {
              atcBtn.textContent = theme.strings.productPreorder;
              atcBtn.classList.add('qb-atc--preorder');
              atcBtn.disabled = false;
            }
          } else if (isPreorderProduct) {
            // Preorder product but no specific variant message
            noticeEl.style.display = 'none';
            if (atcBtn) {
              atcBtn.textContent = theme.strings.productPreorder;
              atcBtn.classList.add('qb-atc--preorder');
              atcBtn.disabled = false;
            }
          } else {
            // Regular product
            noticeEl.style.display = 'none';
            if (atcBtn) {
              atcBtn.textContent = theme.strings.addToCart;
              atcBtn.classList.remove('qb-atc--preorder');
              atcBtn.disabled = false;
            }
          }
        }

        function updateUI(dialog, variant, variantImageMap) {
          var priceEl = dialog.querySelector('[data-qb-price]');
          var compareEl = dialog.querySelector('[data-qb-compare]');
          var variantIdInput = dialog.querySelector('[data-qb-variant-id]');
          var atcBtn = dialog.querySelector('[data-qb-atc]');

          if (!variant) {
            if (atcBtn) {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Unavailable';
              atcBtn.classList.remove('qb-atc--preorder');
            }
            var noticeEl = dialog.querySelector('.qb-preorder-notice');
            if (noticeEl) noticeEl.style.display = 'none';
            return;
          }

          // Update hidden variant ID input
          if (variantIdInput) variantIdInput.value = variant.id;

          // Update price
          if (priceEl) priceEl.textContent = formatMoneyWithDollar(variant.price);

          // Update compare-at price
          var compareAt = Number(variant.compare_at_price || 0);
          var price = Number(variant.price || 0);
          if (compareEl) {
            if (compareAt > price) {
              compareEl.style.display = '';
              compareEl.textContent = formatMoneyWithDollar(compareAt);
            } else {
              compareEl.style.display = 'none';
            }
          }

          // Update image
          if (variantImageMap && variantImageMap[String(variant.id)]) {
            setMainImage(dialog, variantImageMap[String(variant.id)]);
          }

          // Handle preorder / availability — this sets button text and disabled state
          var isPreorderProduct = isQbPreorderProduct(dialog);
          var preorderMap = getQbPreorderMap(dialog);

          if (isPreorderProduct || preorderMap) {
            // Let preorder logic handle button text and state
            updateQbPreorder(dialog, variant);
          } else {
            // Standard product — handle normally
            var available = !!variant.available;
            if (atcBtn) {
              atcBtn.disabled = !available;
              atcBtn.textContent = available
                ? theme.strings.addToCart
                : theme.strings.soldOut;
              atcBtn.classList.remove('qb-atc--preorder');
            }
          }
        }

        document.addEventListener('submit', function (e) {
          var form = e.target.closest && e.target.closest('[data-qb-form]');
          if (!form) return;
          e.preventDefault();

          var dialog = form.closest('dialog.qb-dialog');
          var variantIdInput = form.querySelector('[data-qb-variant-id]');
          var qtyInput = form.querySelector('[data-qb-qty-input]');
          var atcBtn = form.querySelector('[data-qb-atc]');

          var variantId = variantIdInput ? variantIdInput.value : null;
          var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;

          if (!variantId) return;
          if (isNaN(qty) || qty < 1) qty = 1;

          // Determine correct button text to restore after add
          var defaultBtnText = theme.strings.addToCart;
          if (dialog) {
            var isPreorder = isQbPreorderProduct(dialog);
            var preorderMap = getQbPreorderMap(dialog);
            var hasVariantMessage = preorderMap && preorderMap[String(variantId)];
            if (isPreorder || hasVariantMessage) {
              defaultBtnText = theme.strings.productPreorder;
            }
          }

          if (atcBtn) {
            atcBtn.disabled = true;
            atcBtn.textContent = 'Adding…';
          }

          ajaxAddToCart(variantId, qty, function(err) {
            if (err) {
              if (atcBtn) {
                atcBtn.disabled = false;
                atcBtn.textContent = 'Error – try again';
                setTimeout(function(){
                  atcBtn.textContent = defaultBtnText;
                  atcBtn.disabled = false;
                }, 2000);
              }
            } else {
              if (atcBtn) atcBtn.textContent = 'Added!';
              setTimeout(function(){
                if (dialog) closeDialog(dialog);
                if (atcBtn) {
                  atcBtn.disabled = false;
                  atcBtn.textContent = defaultBtnText;
                }

                if (dialog) {
                  var noticeEl = dialog.querySelector('.qb-preorder-notice');
                  if (noticeEl) noticeEl.style.display = 'none';
                  var wrap = dialog.querySelector('[data-qb-qty-dd]');
                  if (wrap) setQtyForWrap(wrap, 1);
                } else if (qtyInput) {
                  qtyInput.value = '1';
                }
              }, 600);
            }
          });
        });
        
        document.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('[data-qb-direct-atc]');
          if (!btn) return;
          e.preventDefault();
          var variantId = btn.getAttribute('data-qb-direct-variant-id');
          if (!variantId) return;
          btn.disabled = true;
          var origText = btn.textContent;
          btn.textContent = 'Adding…';
          ajaxAddToCart(variantId, 1, function(err) {
            btn.disabled = false;
            if (err) {
              btn.textContent = 'Error';
              setTimeout(function(){ btn.textContent = origText; }, 2000);
            } else {
              btn.textContent = 'Added!';
              setTimeout(function(){ btn.textContent = origText; }, 1500);
            }
          });
        });

        function updateQbSoldOutStates(dialog) {
          if (!dialog) return;

          var optionsEl = dialog.querySelector('[data-qb-product-options]');
          var availEl = dialog.querySelector('[data-qb-variants-availability]');
          if (!optionsEl || !availEl) return;

          var options;
          var allVariants;
          try {
            options = JSON.parse(optionsEl.textContent || '[]');
            allVariants = JSON.parse(availEl.textContent || '[]');
          } catch (e) { return; }

          /* Gather currently selected values */
          var selectedValues = [];
          for (var i = 0; i < options.length; i++) {
            var fs = dialog.querySelector('[data-qb-option][data-option-index="' + i + '"]');
            if (!fs) { selectedValues.push(null); continue; }
            var checked = fs.querySelector('input[type="radio"]:checked');
            selectedValues.push(checked ? checked.value : null);
          }

          /* For each option group */
          for (var optIdx = 0; optIdx < options.length; optIdx++) {
            /* Only process included options */
            if (QB_INCLUDED_OPTIONS.indexOf(normQb(options[optIdx])) === -1) continue;

            var group = dialog.querySelector('[data-qb-option][data-option-index="' + optIdx + '"]');
            if (!group) continue;

            /* Build set of available values for this option */
            var availableValues = {};

            for (var vi = 0; vi < allVariants.length; vi++) {
              var v = allVariants[vi];
              if (!v.available) continue;

              var matches = true;
              for (var j = 0; j < options.length; j++) {
                if (j === optIdx) continue;
                if (selectedValues[j] !== null && normQb(v.options[j]) !== normQb(selectedValues[j])) {
                  matches = false;
                  break;
                }
              }
              if (matches) {
                availableValues[normQb(v.options[optIdx])] = true;
              }
            }

            /* Apply/remove soldout class on labels */
            var radios = group.querySelectorAll('input[type="radio"]');
            radios.forEach(function(radio) {
              var val = normQb(radio.value);
              var labelId = radio.getAttribute('id');
              var label = labelId ? group.querySelector('label[for="' + labelId + '"]') : null;

              if (!label) {
                var next = radio.nextElementSibling;
                if (next && next.tagName === 'LABEL') label = next;
              }

              if (label) {
                if (availableValues[val]) {
                  label.classList.remove('opt-label--soldout');
                } else {
                  label.classList.add('opt-label--soldout');
                }
              }
            });
          }
        }
        function showQuickBuy(dialog, btn) {
          openDialog(dialog, btn);

          var data = getDialogData(dialog);
          var selected = getSelectedOptions(dialog);
          var variant = null;

          if (selected.length) {
            variant = findVariant(data.productJson, selected);
          } else if (data.productJson && data.productJson.variants && data.productJson.variants.length) {
            var initialId = dialog.getAttribute('data-qb-initial-variant-id');
            variant =
              data.productJson.variants.find(function(v){ return String(v.id) === String(initialId); }) ||
              data.productJson.variants[0];
          }
           updateUI(dialog, variant, data.variantImageMap);
          filterThumbnailsBySelectedOptions(dialog);
          activateDialogImages(dialog);
       updateQbSoldOutStates(dialog);
          if (!dialog.__qbCloseBound) {
            dialog.__qbCloseBound = true;
            dialog.addEventListener('close', function () {
              unlockScroll();
              closeAllQtyDropdowns();
              setTimeout(function(){ blurOpener(dialog); }, 0);
            });
          }
        }

        document.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('[data-qb-open]');
          if (!btn) return;
          var productId = btn.getAttribute('data-qb-open');
          var dialog = document.getElementById('qb-dialog-' + productId);
          if (dialog) {
            showQuickBuy(dialog, btn);
            return;
          }

          var productUrl = btn.getAttribute('data-qb-product-url');
          if (!productUrl || btn.disabled) return;
          var requestUrl = new URL(productUrl, window.location.href);
          requestUrl.searchParams.set('section_id', 'meka-quick-buy');
          var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewId) requestUrl.searchParams.set('preview_theme_id', previewId);

          btn.disabled = true;
          var originalLabel = btn.textContent;
          btn.textContent = 'Loading…';
          fetch(requestUrl.toString(), { credentials: 'same-origin' })
            .then(function(response) {
              if (!response.ok) throw new Error('Quick buy request failed');
              return response.text();
            })
            .then(function(html) {
              var container = document.createElement('div');
              container.innerHTML = html;
              var fetchedDialog = container.querySelector('dialog.qb-dialog');
              if (!fetchedDialog) throw new Error('Quick buy modal missing');
              document.body.appendChild(fetchedDialog);
              showQuickBuy(fetchedDialog, btn);
            })
            .catch(function() {
              window.location.href = productUrl;
            })
            .finally(function() {
              btn.disabled = false;
              btn.textContent = originalLabel;
            });
        });

        document.addEventListener('click', function (e) {
          var closeBtn = e.target.closest && e.target.closest('[data-qb-close]');
          if (closeBtn) {
            closeDialog(closeBtn.closest('dialog'));
            return;
          }
          var dialog = e.target.closest && e.target.closest('dialog.qb-dialog');
          if (dialog && e.target === dialog) closeDialog(dialog);
        });

        document.addEventListener('click', function (e) {
          var thumb = e.target.closest && e.target.closest('[data-qb-thumb]');
          if (!thumb) return;
          var dialog = thumb.closest('dialog.qb-dialog');
          var src = thumb.getAttribute('data-qb-image');
          if (dialog && src) setMainImage(dialog, src);
        });

        document.addEventListener('change', function (e) {
          var radio = e.target.closest && e.target.closest('.qb-option input[type="radio"]');
          if (!radio) return;

          var dialog = radio.closest('dialog.qb-dialog');

          applyStandColorRule(dialog);

          var data = getDialogData(dialog);
          var selected = getSelectedOptions(dialog);
          var variant = findVariant(data.productJson, selected);
          updateUI(dialog, variant, data.variantImageMap);

          filterThumbnailsBySelectedOptions(dialog);
           updateQbSoldOutStates(dialog);
        });

        document.addEventListener('click', function(e){
          var trigger = e.target.closest && e.target.closest('[data-qb-qty-trigger]');
          if (!trigger) return;

          var wrap = trigger.closest('[data-qb-qty-dd]');
          if (!wrap) return;

          var willOpen = !wrap.classList.contains('is-open');
          closeAllQtyDropdowns(wrap);

          if (willOpen) {
            positionDropdown(wrap);
            wrap.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            var selected = wrap.querySelector('.qb-qty-dd__option.is-selected') || wrap.querySelector('.qb-qty-dd__option');
            if (selected) selected.focus();
          } else {
            wrap.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });

        document.addEventListener('click', function(e){
          var opt = e.target.closest && e.target.closest('[data-qb-qty-option]');
          if (!opt) return;

          var wrap = opt.closest('[data-qb-qty-dd]');
          if (!wrap) return;

          var qty = opt.getAttribute('data-qb-qty-option') || '1';
          setQtyForWrap(wrap, qty);

          wrap.classList.remove('is-open');
          var trigger = wrap.querySelector('[data-qb-qty-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            if (qty !== '10+') {
              trigger.focus();
            }
          }
        });

        document.addEventListener('input', function(e){
          var customInput = e.target.closest && e.target.closest('[data-qb-qty-custom-input]');
          if (!customInput) return;

          var wrap = customInput.closest('[data-qb-qty-dd]');
          if (!wrap) return;

          var value = parseInt(customInput.value, 10);
          if (!isNaN(value) && value >= 1) {
            var hidden = wrap.querySelector('[data-qb-qty-input]');
            if (hidden) hidden.value = String(value);
          }
        });

        document.addEventListener('keydown', function(e){
          if (e.key !== 'Escape') return;
          var openWrap = e.target.closest && e.target.closest('.qb-qty-dd.is-open');
          if (openWrap) {
            e.preventDefault();
            openWrap.classList.remove('is-open');
            var trigger = openWrap.querySelector('[data-qb-qty-trigger]');
            if (trigger) {
              trigger.setAttribute('aria-expanded', 'false');
              trigger.focus();
            }
          } else {
            closeAllQtyDropdowns();
          }
        });

        document.addEventListener('click', function(e){
          if (e.target.closest && e.target.closest('[data-qb-qty-dd]')) return;
          closeAllQtyDropdowns();
        }, true);

      })();
    
